import { useGetTreatmentDuration } from './useGetTreatmentDuration'
import { useGetTreatmentInfo } from './useGetTreatmentInfo'

export const useTreatmentDuration = () => {
  const treatmentInfo = useGetTreatmentInfo()

  const treatmentDuration = useGetTreatmentDuration({
    minDuration: treatmentInfo.treatment?.minDurationInMin,
    maxDuration: treatmentInfo.treatment?.maxDurationInMin,
  })

  return treatmentDuration
}
